import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { LineItemFulfilmentPopover as LineItemFulfilmentPopoverUnified } from './LineItemFulfilmentPopover'
import { LineItemFulfilmentPopoverLegacy } from './LineItemFulfilmentPopoverLegacy'
import type { LineItemFulfilmentPopoverProps } from './LineItemFulfilmentPopoverLegacy'

export const LineItemFulfilmentPopover: React.FC<LineItemFulfilmentPopoverProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentPopoverUnified {...props} />
  ) : (
    <LineItemFulfilmentPopoverLegacy {...props} />
  )
}

export type { LineItemFulfilmentPopoverProps }
